import { TFunction } from 'i18next';

import { PartnerDTO } from 'support/types';

export const getResolverLabel = (
  resolverID: string | null | undefined,
  currentPartner: PartnerDTO | undefined,
  t: TFunction,
): string => {
  if (!resolverID || !currentPartner) {
    return t('common:ownership.procuros');
  }

  const isCurrentPartner = resolverID === currentPartner.id;
  return isCurrentPartner ? t('common:ownership.you') : t('common:ownership.trade_partner');
};
